import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { AdministrationService } from '../../../../services/administration.service'
import { WMSValidators } from '../../../../shared/validators';

@Component({
    selector: 'dialog-state-government-add-new-account-office',
    templateUrl: 'dialog.addnewaccoffice.html',
    styleUrls: ['dialog.addnewaccoffice.css']
})
export class AddNewAccountOfficeStateGovernmentDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    addaccoffform: FormGroup;
    mailtoform: FormGroup;
    mailccform: FormGroup;
    mailbccform: FormGroup;
    isSubmit: boolean = false;
    errorMessage: string = '';
    warrantAuthCode: string = 'NG';
    mailList = [];
    mailToList = [];
    mailCCList = [];
    mailBCCList = [];

    constructor(public dialogRef: MatDialogRef<AddNewAccountOfficeStateGovernmentDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private administrationService: AdministrationService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.addaccoffform = new FormGroup({
            accOffCode: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(32767), WMSValidators.numberOnly]),
            accOff: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(32767)])
        });

        this.mailtoform = new FormGroup({
            mailTo: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.maxLength(50)])
        });

        this.mailccform = new FormGroup({
            mailCC: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.maxLength(50)])
        });

        this.mailbccform = new FormGroup({
            mailBCC: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.maxLength(50)])
        });
    }

    addMailTo() {
        if (this.mailtoform.get('mailTo')!.value.length > 0) {
            this.mailToList.push(this.mailtoform.get('mailTo')!.value);

            this.mailtoform.setValue({
                mailTo: ''
            });
        } else {
            this.openSnackBar('Invalid Email.', '');
        }
    }

    addMailCC() {
        if (this.mailccform.get('mailCC')!.value.length > 0) {
            this.mailCCList.push(this.mailccform.get('mailCC')!.value);

            this.mailccform.setValue({
                mailCC: ''
            });
        } else {
            this.openSnackBar('Invalid Email.', '');
        }
    }

    addMailBCC() {
        if (this.mailbccform.get('mailBCC')!.value.length > 0) {
            this.mailBCCList.push(this.mailbccform.get('mailBCC')!.value);

            this.mailbccform.setValue({
                mailBCC: ''
            });
        } else {
            this.openSnackBar('Invalid Email.', '');
        }
    }

    deleteMailToList(mailTo: string) {
        var index = this.mailToList.indexOf(mailTo);
        if (index !== -1) this.mailToList.splice(index, 1);
    }

    deleteMailCcList(mailCc: string) {
        var index = this.mailCCList.indexOf(mailCc);
        if (index !== -1) this.mailCCList.splice(index, 1);
    }

    deleteMailBccList(mailBcc: string) {
        var index = this.mailBCCList.indexOf(mailBcc);
        if (index !== -1) this.mailBCCList.splice(index, 1);
    }

    onSubmit(form: FormGroup) {
        if (this.mailToList.length === 0) {
            this.openSnackBar('Mail To cannot be empty.', '');
            return;
        }

        let cfm = confirm("Are you sure you want to the new Account Office?");

        if (cfm) {
            this.isSubmit = true;

            let accountOfficeDetail = {
                WarrantAuthCode: this.data.warrantauthcode,
                AccOffCode: this.addaccoffform.get('accOffCode')!.value,
                AccOff: this.addaccoffform.get('accOff')!.value,
                MailTo: this.mailToList,
                MailCc: this.mailCCList,
                MailBcc: this.mailBCCList
            }

            let save_sub = this.administrationService.ngrAddAccOff(accountOfficeDetail)
                .subscribe(
                    (value) => {
                        if (value.status === 204) {

                        } else if (value.status === 200) {
                            this.isSubmit = false;
                            this.dialogRef.close('Add new successful');
                        } else {

                        }
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.isSubmit = false;
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}